	
  <!-- 消息提示框

  •	支持 4 种类型：success, error, warning, info
	•	支持自动关闭、手动关闭
	•	支持多个提示同时显示
	•	支持全局调用：this.$message({ type: 'success', message: '操作成功' }) -->

<template>
  <div
    class="my-message"
    :class="type"
    @mouseenter="clearTimer"
    @mouseleave="startTimer"
  >
    <span class="title">{{ message }}</span>
  </div>
</template>

<script>
export default {
  props: {
    type: { type: String, default: "info" },
    message: { type: String, required: true },
    duration: { type: Number, default: 3000 },
  },
  data() {
    return { timer: null };
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(this.close, this.duration);
      }
    },
    clearTimer() {
      clearTimeout(this.timer);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
@function toRem($x) {
  @return $x / 37.5 * 1rem;
}
.my-message {
  position: fixed;
  left: 50%;
  top: 40px;
  transform: translateX(-50%);
  display: inline-block;
  padding: 9px 12px;
  color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  pointer-events: all;
  line-height: 1;
}
.title {
  font-size: toRem(14);
}
.my-message.success {
  background: #67c23a;
}
.my-message.error {
  background: #f56c6c;
}
.my-message.warning {
  background: rgba($color: #e6a23c, $alpha: 1);
}
.my-message.info {
  background: #909399;
}
.my-message .title {
  font-size: toRem(14);
}
.my-message .close {
  float: right;
  cursor: pointer;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// message.vue?a2f1af02